import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbTrail = ({ items = [] }) => {
  if (!items || items?.length === 0) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-1 text-sm text-muted-foreground py-3" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        {items?.map((item, index) => {
          const isLast = index === items?.length - 1;
          
          return (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <Icon 
                  name="ChevronRight" 
                  size={16} 
                  className="mx-2 text-muted-foreground/60" 
                />
              )}
              {isLast || !item?.path ? (
                <span className="font-medium text-foreground truncate max-w-[200px] sm:max-w-none flex items-center">
                  {item?.label}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="hover:text-primary transition-smooth truncate max-w-[150px] sm:max-w-none flex items-center"
                  title={item?.label}
                >
                  {item?.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadcrumbTrail;
